import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { cartSelector } from '../../store/user/user.selector';
import emptyCart from '@images/icons/empty-cart.png';
import CustomButton from '../../components/UI/CustomButton';
import { useNavigate } from 'react-router-dom';
import { privateRoutes } from '../../configs/routes';
import CartList from './CartList';
import SummaryCart from './Summary';
import ExamsSection from './Exams';

const Cart = () => {
  const navigate = useNavigate();
  const cartList = useSelector(cartSelector);

  if (cartList.length === 0)
    return (
      <Box className='flexCenter' flexDirection='column' height='70vh'>
        <img src={emptyCart} width={212} alt='' />
        <Typography color='primary.darker' fontWeight='bold' fontSize='x-large'>
          سبد خرید شما خالی است
        </Typography>
        <Typography color='text.dark' fontSize='small' mt={2} mb={1} textAlign='center' width='80%'>
          می‌توانید برای دیدن دوره ها و تست های بیشتر روی دکمه زیر کلیک کنید!
        </Typography>
        <CustomButton variant='outlined' onClick={() => navigate(privateRoutes.product)}>
          <Typography>دیدن محصولات</Typography>
        </CustomButton>
      </Box>
    );

  return (
    <Box p={2}>
      <Grid container mt={2} spacing={2}>
        <Grid item lg={8} xs={12}>
          <CartList />
        </Grid>
        <Grid item lg={4} xs={12}>
          <SummaryCart />
        </Grid>
      </Grid>

      <ExamsSection />

      {/*<CoursesSection />*/}
    </Box>
  );
};

export default Cart;
